module.exports = __webpack_public_path__ + "img/mobapp-category-banner.c5c2505.png";